import type { QueryClient } from '@tanstack/react-query';
import { statusKeys } from '@shared/api/query-keys';

/**
 * Status invalidation helpers (Server-state rebuild, P2) — the single place that knows
 * what to refresh when status changes. Replaces the ~28 hand-written `base`+`tasks`(+`presets`)
 * invalidation triplets that existed only because the legacy keys couldn't cascade.
 */

/**
 * Something in the audit's status changed (step CRUD, status set, save, reorder, preset
 * apply…): refresh the whole status subtree. `statusKeys.all` is a prefix of overview +
 * tasks + presets, so this one call cascades. `refetchType: 'active'` keeps it cheap.
 */
export const invalidateStatus = (qc: QueryClient, auditId?: string) =>
  qc.invalidateQueries({ queryKey: statusKeys.all(auditId), refetchType: 'active' });

/**
 * Only the preset library changed (create / rename / delete a preset). These don't touch
 * the live status board, so scope the refresh to presets.
 */
export const invalidateStatusPresets = (qc: QueryClient, auditId?: string) =>
  qc.invalidateQueries({ queryKey: statusKeys.presets(auditId), refetchType: 'active' });
